module.exports = __webpack_public_path__ + "img/f787d409-0c38-426c-98ce-539c0060c400.97d29489.webp";